import Immutable from 'seamless-immutable';
import actions from './actions';

const initState = Immutable.from({
	user: null,
	isChangeEmailLoading: { status: false }
});

export default function authReducer(state = initState, { type, payload }) {
	switch (type) {
		case actions.PROFILE_REFRESH: {
			return Immutable.set(state, 'user', payload.user);
		}
		case actions.CHANGE_EMAIL_LOADING_SET: {
			return Immutable.set(state, 'isChangeEmailLoading', payload.isChangeEmailLoading);
		}
		default: {
			return state;
		}
	}
}
